import { SelectProps } from "@mantine/core"
import { Select } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { filtersValidationType } from "@tfg/types/schemas/products"
import { removeUndefined } from "@tfg/types/schemas/utils"

import { useFindProductBrandValues } from "~/gen/api"

interface Props extends SelectProps {
  filtersValue: filtersValidationType
  setFiltersValue: (value: filtersValidationType) => void
}

export const ProductBrandFilter = ({
  filtersValue,
  setFiltersValue,
  ...props
}: Props) => {
  const { t } = useTranslation("products")

  const { data: productBrandValues, isLoading } = useFindProductBrandValues({
    ...removeUndefined(filtersValue),
  })

  if (productBrandValues?.data.length === 0) {
    return null
  }

  return (
    <Select
      // defaults
      w={150}
      searchable
      clearable
      isLoading={isLoading}
      // overrides
      {...props}
      // managed
      placeholder={t("lists.placeholders.brand")}
      data={productBrandValues?.data.map((brand) => ({
        value: brand,
        label: brand,
      }))}
      value={filtersValue.brand ?? null}
      onChange={(value) => {
        setFiltersValue({ ...filtersValue, brand: value ?? undefined })
      }}
    />
  )
}
